import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=b8754b5c"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8754b5c')) {
      api.createRecord('b8754b5c', component.options)
    } else {
      api.reload('b8754b5c', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=b8754b5c", function () {
      api.rerender('b8754b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/service-satisfaction-questionnaire/Wrapper.vue"
export default component.exports